"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.search");

require("core-js/modules/es.string.link");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _UrlUtils = _interopRequireDefault(require("@icare/core/lib/utils/UrlUtils"));

var _MobileToolBarItem = _interopRequireDefault(require("../MobileToolBarItem"));

var _ShowLinks = require("../../utils/ShowLinks");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MobileToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(MobileToolbar, _React$Component);

  var _super = _createSuper(MobileToolbar);

  function MobileToolbar() {
    _classCallCheck(this, MobileToolbar);

    return _super.apply(this, arguments);
  }

  _createClass(MobileToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.classList.add('has-mobile-toolbar');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.classList.remove('has-mobile-toolbar');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          auth = _this$props.auth,
          toggleSearch = _this$props.toggleSearch,
          isSearching = _this$props.isSearching,
          toggleMenu = _this$props.toggleMenu,
          isMenuOpen = _this$props.isMenuOpen;
      return /*#__PURE__*/_react.default.createElement("nav", {
        className: "mobile-toolbar"
      }, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", {
        key: 'mobile-toolbar-item-menu'
      }, /*#__PURE__*/_react.default.createElement(_MobileToolBarItem.default, {
        label: "Menu",
        tag: "button",
        onClick: function onClick() {
          return toggleMenu(!isMenuOpen);
        },
        icon: isMenuOpen ? 'close-thick' : 'menu'
      })), header && header.search && (0, _ShowLinks.showLink)(auth, header.search.showAuth) && /*#__PURE__*/_react.default.createElement("li", {
        key: 'mobile-toolbar-item-search'
      }, /*#__PURE__*/_react.default.createElement(_MobileToolBarItem.default, {
        label: "Search",
        tag: "button",
        onClick: function onClick() {
          return toggleSearch(!isSearching);
        },
        icon: isSearching ? 'close-thick' : 'search'
      })), header && header.links.map(function (link, i) {
        if (!link.mobileBar) {
          return null;
        } else if (!(0, _ShowLinks.showLink)(auth, link.showAuth)) {
          return null;
        } else {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: "mobile-toolbar-item-".concat(i)
          }, /*#__PURE__*/_react.default.createElement(_MobileToolBarItem.default, {
            key: "".concat(i).concat(link.link, "-toolbar"),
            label: link.label,
            tag: _UrlUtils.default.isAbsoluteUrl(link.link) ? 'a' : _reactRouterDom.Link,
            href: link.link,
            to: link.link,
            icon: link.mobileIcon,
            target: link.target
          }));
        }
      })));
    }
  }]);

  return MobileToolbar;
}(_react.default.Component);

_defineProperty(MobileToolbar, "propTypes", {
  auth: _propTypes.default.object.isRequired,
  isSearching: _propTypes.default.bool.isRequired,
  toggleSearch: _propTypes.default.func.isRequired,
  isMenuOpen: _propTypes.default.bool.isRequired,
  toggleMenu: _propTypes.default.func.isRequired,
  header: _propTypes.default.object.isRequired
});

var _default = MobileToolbar;
exports.default = _default;
//# sourceMappingURL=MobileToolbar.js.map